import { DISABLED_OPACITY } from "../../styles/colors/consts";

// default argument stops getThemeType test from failing as css isn't imported in jest
export default function colorWithOpacity(
  hexColor: string = "",
  opacityDecimal: number
) {
  const removeHash = hexColor.replace("#", "");
  const rgb = removeHash.split(/(.{2})/g).filter(Boolean);

  const decimalChunks = rgb.map(hexToDecimal);

  return `rgba(${decimalChunks.join(",")}, ${opacityDecimal})`;
}

export function colorWithDisabledOpacity(hexColor: string) {
  return colorWithOpacity(hexColor, parseFloat(DISABLED_OPACITY));
}

export function hexToDecimal(hex: string) {
  return parseInt(hex, 16);
}
